import React from 'react';
import { AlertCircle, Loader2 } from '@/components/icons';
import { Button } from '@/components/ui/button';

export function LoadingState({ label = 'Caricamento dati…', compact = false }) {
  return (
    <div className={`flex items-center justify-center gap-3 text-muted-foreground ${compact ? 'py-5' : 'py-12'}`} role="status" aria-live="polite">
      <Loader2 className="h-5 w-5 animate-spin text-primary" aria-hidden="true" />
      <span className="text-sm">{label}</span>
    </div>
  );
}

export function ErrorState({ title = 'Impossibile caricare i dati', description = 'Si è verificato un errore. Riprova.', onRetry, compact = false }) {
  return (
    <div className={`rounded-lg border border-red-200 bg-red-50 text-red-900 ${compact ? 'p-4' : 'p-6'}`} role="alert">
      <div className="flex items-start gap-3">
        <AlertCircle className="h-5 w-5 mt-0.5 text-red-600 flex-none" aria-hidden="true" />
        <div className="min-w-0 flex-1">
          <p className="font-medium">{title}</p>
          <p className="mt-1 text-sm text-red-700">{description}</p>
          {onRetry && <Button type="button" variant="outline" onClick={onRetry} className="mt-3 h-10 border-red-300 text-red-700 hover:bg-red-100">Riprova</Button>}
        </div>
      </div>
    </div>
  );
}
